import React from 'react';
import { Input } from 'antd';

export default function EditableNumber({ value, onChange }) {
    return (
        <Input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            type="number"
            size="small"
            min={0}
            style={{
                width: '80px',
                marginRight: '5px',
                color: 'red',
            }}
        />
    );
}
